import { connect } from 'react-redux'
import { withWizard } from 'react-albus'
import { setWizards, resetStockWizard } from 'core/components/wizard/actions'
import Stock from './Stock'

const mapStateToProps = state => ({
  wizards: state.wizards
})

const mapDispatchToProps = {
  setWizards,
  resetStockWizard
}

// For test.js
export const ConnectedStock = connect(mapStateToProps, mapDispatchToProps)(withWizard(Stock))

export default withWizard(connect(mapStateToProps, mapDispatchToProps)(Stock))
